import reduxCrud from 'redux-crud';

const accountsActionCreators = reduxCrud.actionCreatorsFor('accounts', {
  key: '_id',
});
const actionTypes = reduxCrud.actionTypesFor('accounts', { key: '_id' });

export default accountsActionCreators;
export { actionTypes };
